import $ from 'jquery';

function popup() {
    if ($('.popup').length) {
        $('.popup').each(function() {
            let popup = $(this);
            let content = popup.find('.popup-content');
            let id = popup.attr('id');
            let close = popup.find('.popup-close');
            let openBtn = $('a[href="#' + id + '"], [data-popup="#' + id + '"]');

            openBtn.on('click', function(e) {
                e.preventDefault();
                popup.fadeIn();
            });

            close.on('click', function(e) {
                e.preventDefault();
                popup.fadeOut();
            });

            // Event to close popup if click outside of '.popup-inner'
            popup.on('click', function(e) {
                if (!$(e.target).closest('.popup-content').length) {
                    popup.fadeOut();
                }
            });

            // Stop propagation to prevent popup from closing when clicking inside '.popup-inner'
            content.on('click', function(e) {
                e.stopPropagation();
            });
        });
    }
}

export { popup };
